import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { SharedService } from '../../services/shared.service';
import { ModalID } from '../../models/constants';
import { InventoryRequestService } from 'src/app/vendor-data/inventory-request-lists/inventory-request.service';
import { PurchaseOptimizerItem } from '../../models/general';

@Component({
  selector: 'app-optimizer-item',
  templateUrl: './optimizer-item.component.html',
  styleUrls: ['./optimizer-item.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule],
})
export class OptimizerItemComponent implements OnInit {
  optimizer_form: FormGroup;
  
  constructor(
    private fb: FormBuilder,
    public sharedService: SharedService,
    private inventoryRequestService: InventoryRequestService,
  ) {
    this.optimizer_form = this.fb.group({
      item_name: new FormControl({ value: null, disabled: false }),
      item_description: new FormControl({ value: null, disabled: false }, [Validators.required]),
      item_upc: new FormControl({ value: null, disabled: false }, [Validators.required]),
      desired_qty: new FormControl({ value: 1, disabled: false }, [Validators.required, Validators.min(1)]),
    });
  }

  ngOnInit(): void {
    this.sharedService.inventory_search_item_selected$.subscribe({
      next: (item) => {
        if (item) {
          this.optimizer_form.patchValue({
            item_upc: item.upc,
            item_name: item.mfg_part_number || item.item_number || item.manufacturer,
            item_description: item.desc1 || item.desc2,
          });
        }
      }
    });
  }

  searchItem() {
    const upc = this.optimizer_form.get('item_upc').value;
    const description = this.optimizer_form.get('item_description').value;

    if (upc && upc.length >= 12 && !description) {
      this.sharedService.openStatusSpinner('Searching Live Inventory...');
      this.sharedService.getVendorData(upc).subscribe({
        next: (live_inventory) => {
          this.sharedService.closeStatusSpinner();
          if (live_inventory && (live_inventory.desc1 || live_inventory.mfg_part_number)) {
            this.optimizer_form.patchValue({
              item_name: live_inventory.mfg_part_number || '',
              item_description: live_inventory.desc1 || live_inventory.desc2 || '',
            });
          } else {
            this.sharedService.openInventorySearchModal();
          }
        },
        error: (err) => {
          console.error('Error searching live inventory', err);
          this.sharedService.closeStatusSpinner();
          this.sharedService.openInventorySearchModal();
        }
      });
    } else {
      this.sharedService.openInventorySearchModal();
    }
  }

  submitClick() {
    if (this.optimizer_form.invalid) return;
    
    const formValues = this.optimizer_form.getRawValue();
    const purchaseOptimizerItem = new PurchaseOptimizerItem();
    purchaseOptimizerItem.desired_qty = formValues.desired_qty;
    purchaseOptimizerItem.item_name = formValues.item_name;
    purchaseOptimizerItem.item_description = formValues.item_description;
    purchaseOptimizerItem.item_upc = formValues.item_upc;

    (purchaseOptimizerItem as any).company_id = this.sharedService.company_info?.company_id;
    
    this.inventoryRequestService.createPurchaseOptimizerItem(purchaseOptimizerItem).subscribe({
      next: () => {
        this.sharedService.raiseSuccessToast('Purchase Optimizer Item saved successfully!');
        this.inventoryRequestService.refreshRequests$.next();
        this.closeModalClick();
      },
      error: (err) => {
        this.sharedService.raiseErrorToast('Failed to create Purchase Optimizer Item');
      }
    });
  }

  closeModalClick(): void {
    this.optimizer_form.reset({ desired_qty: 1 });
    // Assuming we use a similar modal ID mapping logic
    this.sharedService.closeModal(ModalID.optimizer_item);
  }
}
